import { SeatFeature } from '../charter.types';

const FEATURE_DESCRIPTOR_DEFAULT = {
  label: 'Regular',
  color: '#e0f2f1',
};

const FEATURE_DESCRIPTORS: Array<{
  match: (feature: SeatFeature) => boolean;
  label: string;
  color: string;
}> = [
  {
    match: (feature) => !feature.hasExtraLegroom && feature.isExitRow,
    label: 'Exit Row',
    color: '#f593a0',
  },
  {
    match: (feature) => feature.hasExtraLegroom && !feature.isExitRow,
    label: 'Extra Leg Room',
    color: '#e3f2fd',
  },
  {
    match: (feature) => feature.hasExtraLegroom && feature.isExitRow,
    label: 'Extra Leg Room & Emergency',
    color: '#ffebee',
  },
];

export const getSeatFeatureDescriptor = (feature: SeatFeature) =>
  FEATURE_DESCRIPTORS.find(({ match }) => match(feature)) ?? FEATURE_DESCRIPTOR_DEFAULT;
